import React from 'react';
import Certification, { certificationPropTypes } from './certification';
import SubSpecialties from './sub_specialties';
import Specialties, { specialtiesPropTypes } from './specialties';
import './index.scss';
import VcardToggle from './vcard_toggle';
import PrintBrokerBioToggle from './print_broker_bio_toggle';
import Organization, { organizationPropTypes } from './organizations';
import PropTypes from 'prop-types';

export default function UserProfile(props) {
  return (
    <React.Fragment>
      <VcardToggle showVcard={props.showVcardOnBrokerPlugin}/>
      <PrintBrokerBioToggle showPrintBrokerBio={props.showPrintBrokerBioOnBrokerPlugin} />
      <hr/>
      <Certification
        allBrokerCertifications={props.allBrokerCertifications}
        showCertificationsOnBrokerPlugin={props.showCertificationsOnBrokerPlugin}
        showCertificationsOnDocuments={props.showCertificationsOnDocuments}
        showCertificationsOnEmails={props.showCertificationsOnEmails}
        showCertificationsOnInventoryPlugin={props.showCertificationsOnInventoryPlugin}
        userCertifications={props.userCertifications}
      />
      <Specialties
        allBrokerSpecialties={props.allBrokerSpecialties}
        showSpecialtiesOnBrokerPlugin={props.showSpecialtiesOnBrokerPlugin}
        userSpecialties={props.userSpecialties}
      />
      <SubSpecialties
        allSubSpecialties={props.allSubSpecialties}
        showSubSpecialtiesOnBrokerPlugin={props.showSubSpecialtiesOnBrokerPlugin}
        userSubSpecialties={props.userSubSpecialties}
      />
      <Organization
        allBrokerOrganizations={props.allBrokerOrganizations}
        showOrganizationsOnBrokerPlugin={props.showOrganizationsOnBrokerPlugin}
        userOrganizations={props.userOrganizations}
      />
    </React.Fragment>
  );
}

UserProfile.propTypes = {
  showPrintBrokerBioOnBrokerPlugin: PropTypes.bool.isRequired,
  showVcardOnBrokerPlugin: PropTypes.bool.isRequired,
  ...certificationPropTypes,
  ...specialtiesPropTypes,
  ...organizationPropTypes,
};
